<div class="app-frame mat-app-background" [class.public-page-frame]="publicDataDeletionPage">
  <ng-container *ngIf="publicDataDeletionPage; else accountShell">
    <router-outlet></router-outlet>
  </ng-container>
  <ng-template #accountShell>
    <app-nav></app-nav>
  </ng-template>
</div>
